import { memo, FC } from 'react';
import {
  MenuItem,
  MenuItemLabel,
  NavMenuItemButton,
} from 'components/BKJMainNavigation/BKJMainNavigation.styled';
import { INavMenuItemProps } from 'components/BKJMainNavigation/BKJMainNavigation.types';
import { NavMenuIcon } from 'components/BKJMainNavigation/src/NavMenuIcon';
import { deepEquals } from 'utils/deepEquals';
import { isCurrentLanguageFrench } from 'providers/i18NextProvider.constants';

const Component: FC<INavMenuItemProps> = (props): JSX.Element => {
  return (
    <NavMenuItemButton
      $label={props.label}
      $disabled={props.disabled}
      onClick={props.onClick}
      $isOpen={!!props.isOpen}
      {...props}
    >
      <MenuItem>
        <NavMenuIcon iconName={props.icon} color="White" />
        <MenuItemLabel
          $isOpen={props.isOpen}
          $disabled={props.disabled}
          $showPreLine={isCurrentLanguageFrench()}
        >
          {props.label}
        </MenuItemLabel>
      </MenuItem>
    </NavMenuItemButton>
  );
};

export const NavMenuItem = memo(Component, deepEquals);
